import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
  Typography
} from '@mui/material';
import moment from 'moment';

const AIAnalysisConfigDialog = ({ open, onClose, onAnalyze }) => {
  const [duration, setDuration] = useState('w');
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));

  const handleAnalyze = () => {
    onAnalyze({ duration, date });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ background: 'linear-gradient(135deg, #2AAB6C 0%, #097EB7 100%)', color: 'white' }}>
        🤖 Configure AI Analysis
      </DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
          <FormControl fullWidth>
            <InputLabel id="duration-label">Duration</InputLabel>
            <Select
              labelId="duration-label"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              label="Duration"
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300
                  }
                }
              }}
            >
              <MenuItem value="d">Day</MenuItem>
              <MenuItem value="w">Week</MenuItem>
              <MenuItem value="m">Month</MenuItem>
              <MenuItem value="y">Year</MenuItem>
            </Select>
          </FormControl>
          <TextField
            fullWidth
            type="date"
            label="End Date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ max: moment().format('YYYY-MM-DD') }}
          />
          <Typography variant="caption" color="text.secondary">
            Analysis will include data from the selected duration ending on the chosen date
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleAnalyze}
          variant="contained"
          sx={{ background: 'linear-gradient(135deg, #2AAB6C 0%, #097EB7 100%)' }}
        >
          Analyze
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AIAnalysisConfigDialog;
